var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.serverError)?_c('div',_vm._l((_vm.serverError.errors),function(e,index){return _c('error',{key:index,attrs:{"error":e}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }